// extracted by mini-css-extract-plugin
export default {"fadeIn":"FI6B05JRDZxM3ITkdOd7"};